<template>
  <OmtLayoutHeaderFooter
    bg="#F6F6F9"
    :footer="false"
    :header="{ titleLabel: 'Análise de Pele' }"
  >
    <router-view />
  </OmtLayoutHeaderFooter>
</template>

<script>
export default {
  name: "SkiniverIndex",
  mounted() {
    this.$root.$emit("show-back-button");
  }
};
</script>
